export const periods = [
    '2025-06-02',
    '2025-06-23',
    '2025-06-30',
    '2025-07-07',
];

export const dishes = [
    '4982',
    '4976',
    '4979',
    '4981',
    '4980',
    '4974',
    '4978',
];
